import React from 'react';
import { QuestionHeading, QuestionPreviewField } from './QuestionBlockShared';

function TextAreaBlock({ block, position }) {
    return (
        <div className="ecx-survey-q">
            <QuestionHeading block={block} position={position} />
            <QuestionPreviewField>
                <textarea
                    className="form-control form-control-sm"
                    rows={block.rows || 4}
                    placeholder={block.placeholder || 'Answer'}
                    disabled
                />
                {block.maxLength ? (
                    <div className="ecx-survey-q__hint">Maximum {block.maxLength} characters</div>
                ) : null}
            </QuestionPreviewField>
        </div>
    );
}

export default TextAreaBlock;
